<template>
<v-layout class="fill-height">
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
        <v-col cols="12" class="pt-1">
          <header-sidebar></header-sidebar>
          <v-card class="table-content">
            <v-snackbar
              v-model="snackbar"
              :color="color"
              right
              top
              app
            >
              {{snackbarText}}
              <v-btn
                text
                dark
                @click="snackbar = false"
              >
                Fermer
              </v-btn>
            </v-snackbar>
            <v-card-title>
              <v-btn text :ripple="false" depressed style="background:transparent !important;" :to="{ name: 'listingFolder'}" exact icon><v-icon>mdi-arrow-left</v-icon></v-btn> Dossier N°{{currentDossier.numdossier}}
              <!--<v-radio-group v-model="row" row>
                <v-radio label="Import" value="import"></v-radio>
                <v-radio label="Export" value="export"></v-radio>
              </v-radio-group> -->
                <v-spacer></v-spacer>
                <v-progress-circular
                  v-if="loadEdit"
                  :size="10"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                <div class="ml-2"><v-btn :to="{ name: 'listingFolder'}" exact depressed small text color="primary">Retour</v-btn></div>
                <div class="ml-2"><v-btn depressed small style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white; border-radius:25px;"  @click="editFolder(currentDossier.id)">Editer</v-btn></div>
                <!--<div class="ml-2"><v-btn depressed small style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white; border-radius:25px;"  :to="{ name: 'singleFolderFacture', params: { id: this.$route.params.id }}">Liste Facture(s)</v-btn></div>-->

            </v-card-title>
            <v-row>
                <v-col cols="12" md="4" class="text-left">
                  <span class="heading-singleFolder">Informations Générales</span>
                  <v-list two-line>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Numéro Dossier</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.numdossier}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Classe Dossier</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.classe}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Type Dossier</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.type}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  <template v-if="currentDossier.classe == 'Complet' || currentDossier.classe == 'Groupage'">
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Navire</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.navire}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Numéro Voyage</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.voyage}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Numéro Escale</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.escale}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Date Escale/Sortie</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.date_escale | formatDate}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Date d'Embarquement</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.from_date | formatDate}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Date de Débarquement</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.to_date | formatDate}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Port de Chargement</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.port_from}} - {{currentDossier.port_from_name}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Port de Déchargement</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.port_to}} - {{currentDossier.port_to_name}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Armateur</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.armateur}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-if="currentDossier.classe == 'Groupage'">
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Type Conteneur</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.conteneur_type}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>N° Conteneur</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.conteneur_num}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>N°Escale Magasin</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.num_escale_magasin}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Date Dépotage</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.date_depotage | formatDate}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-if="currentDossier.classe == 'Aérien'">
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Compagnie Aérienne</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.compagnie_aerienne}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>N° LTA</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.num_lta}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>N° Vol</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.num_vol}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Aéroport de Départ</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.aeroport_depart}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Date de Départ</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.from_date | formatDate}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Aéroport d'Arrivée</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.aeroport_arrivee}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-subtitle>Date d'Arrivée</v-list-item-subtitle>
                        <v-list-item-title>{{currentDossier.to_date | formatDate}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  </v-list>
                </v-col>
                <v-col cols="12" md="8" class="text-left">
                  <v-layout>
                     <span class="heading-singleFolder">Avis</span>
                    <div class="ml-2"><v-btn depressed dense small style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white; border-radius:25px;"  @click="addAvis">Nouvel Avis</v-btn></div>
                  </v-layout>
                  <v-row>
                    <v-timeline style="width:100%" v-if="currentAvis.length > 0" dense>
                      <v-timeline-item
                        v-for="(avis, index) in currentAvis"
                        :key="avis.id"
                        left small
                      >
                        <v-expansion-panels v-model="panel[index]">
                          <v-expansion-panel style="max-width:98%;" @change="changePanel(avis.id)">
                            <v-expansion-panel-header>AVIS N°{{avis.num_avis}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-card class="elevation-0">
                                <v-card-text class="pt-0 pb-0 pl-0 pr-0">
                                  <v-tabs
                                    v-model="avis.tab"
                                    background-color="transparent"
                                    color="basil"
                                    hide-slider
                                    grow
                                  >
                                    <v-tab
                                      v-for="item in items"
                                      class="avis-tab"
                                      :key="item"
                                      @click="$router.push({name: 'singleFolder', params: {id: currentDossier.id}, query: {avisid: avis.id, tab: item.toLowerCase()}})"
                                    >
                                      {{ item }}
                                    </v-tab>
                                  </v-tabs>

                                  <v-tabs-items v-model="avis.tab">
                                    <v-tab-item
                                    >
                                    <v-row>
                                      <v-col cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                          <v-list two-line>
                                            <v-list-item >
                                              <v-list-item-content>
                                                <v-list-item-subtitle>N°AVIS</v-list-item-subtitle>
                                                <v-list-item-title>{{avis.num_avis}}</v-list-item-title>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </v-list>
                                      </v-col>
                                      <v-col cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item >
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>Date Création</v-list-item-subtitle>
                                                  <v-list-item-title>{{avis.date | formatDate}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                      <v-col cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item >
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>Client</v-list-item-subtitle>
                                                  <v-list-item-title>{{avis.client.fullname}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                      <v-col cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item >
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>P/C</v-list-item-subtitle>
                                                  <v-list-item-title>{{avis.pc}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                      <v-col cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item>
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>Correspondant</v-list-item-subtitle>
                                                  <v-list-item-title v-if="avis.correspondant">{{avis.correspondant.nom}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                      <v-col cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item>
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>Fournisseur</v-list-item-subtitle>
                                                  <v-list-item-title>{{avis.fournisseur}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                      <v-col cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item>
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>Terme</v-list-item-subtitle>
                                                  <v-list-item-title>{{avis.terme}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                      <v-col cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item >
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>Agent Commercial</v-list-item-subtitle>
                                                  <v-list-item-title v-if="avis.agent">{{avis.agent.nom}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                      <v-col v-if="currentDossier.classe !== 'Aérien'" cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item>
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>BL</v-list-item-subtitle>
                                                  <v-list-item-title>{{avis.bl}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                      <v-col v-if="currentDossier.classe === 'Groupage'" cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item>
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>Valeur</v-list-item-subtitle>
                                                  <v-list-item-title>{{avis.valeur}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                      <v-col v-if="currentDossier.classe === 'Groupage'" cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item>
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>Bureau</v-list-item-subtitle>
                                                  <v-list-item-title>{{avis.bureau}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                      <v-col v-if="currentDossier.classe === 'Groupage'" cols="12" md="4"  class="pt-0 pb-0 pl-0 pr-0">
                                            <v-list two-line>
                                              <v-list-item>
                                                <v-list-item-content>
                                                  <v-list-item-subtitle>Code Magasin</v-list-item-subtitle>
                                                  <v-list-item-title>{{avis.code_magasin}}</v-list-item-title>
                                                </v-list-item-content>
                                              </v-list-item>
                                            </v-list>
                                      </v-col>
                                    </v-row>
                                    </v-tab-item>


                                    <v-tab-item
                                    >
                                      <v-data-table
                                        v-if="currentDossier.classe == 'Complet'"
                                        :headers="headersCargo"
                                        :items="avis.marchandises"
                                        hide-default-footer
                                        class="elevation-0"
                                      ></v-data-table>
                                      <v-data-table
                                        v-if="currentDossier.classe == 'Groupage'"
                                        :headers="headersCargoGroupage"
                                        :items="avis.marchandises"
                                        hide-default-footer
                                        class="elevation-0"
                                      ></v-data-table>
                                      <v-data-table
                                        v-if="currentDossier.classe == 'Aérien'"
                                        :headers="headersCargoAerien"
                                        :items="avis.marchandises"
                                        hide-default-footer
                                        class="elevation-0"
                                      ></v-data-table>
                                    </v-tab-item>
                                    <v-tab-item
                                    >
                                      <v-data-table
                                        :headers="headersCosts"
                                        :items="avis.prestations"
                                        hide-default-footer
                                        :items-per-page=100
                                        class="elevation-0"
                                      >
                                        <template v-slot:[`item.montant`]="{ item }">
                                            {{item.montant.toFixed(3)}}
                                        </template>

                                        <template v-slot:[`item.cour`]="{ item }">
                                            {{item.cour.toFixed(3)}}
                                        </template>

                                        <template v-slot:[`item.montantDevise`]="{ item }">
                                            {{item.montantDevise.toFixed(2)}}
                                        </template>


                                      </v-data-table>
                                      <v-col class="mt-auto ml-auto" cols="12" md="6" style="text-align: right; font-size:16px; line-height:25px">
                                          Montant non taxable : {{avis.totalnt.toFixed(3)}} DT <br>
                                          Montant taxable : {{avis.totalt.toFixed(3)}}  DT <br>
                                          Total TVA : {{avis.totaltva.toFixed(3)}} DT <br>
                                          Timbre Fiscal : {{avis.timbre.toFixed(3)}} DT <br>
                                          Montant TTC : {{avis.total.toFixed(3)}} DT <br>
                                      </v-col>
                                    </v-tab-item>
                                  </v-tabs-items>
                                  <v-btn color="blue-grey" class="ma-2 white--text elevation-0" :disabled="avis.facture_timbrage && avis.facture_timbrage.reglement.length > 0" :loading="loadEdit" @click="editAvis(avis.id)" small>
                                    <v-icon left>mdi-pencil</v-icon> Editer
                                  </v-btn>
                                  <v-btn color="blue-grey" class="ma-2 white--text elevation-0" @click="printAvis(avis.id)" small>
                                    <v-icon left>mdi-printer</v-icon> Imprimer
                                  </v-btn>
                                  <!--
                                  <v-btn color="blue-grey" class="ma-2 white--text elevation-0" v-if="Object.keys(avis.facture).length === 0" @click="openNewFacture(avis.id)" small>
                                    <v-icon left>mdi-cash-usd-outline</v-icon> Facturer
                                  </v-btn>
                                  <v-menu
                                    v-else
                                    open-on-hover
                                    :close-on-content-click="false"
                                    :nudge-width="300"
                                    offset-y
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        color="blue-grey" class="ma-2 white--text elevation-0"
                                        small
                                      >
                                        <v-icon left>mdi-cash-usd-outline</v-icon> Facture(s)
                                      </v-btn>
                                    </template>
                                    <v-card>
                                      <v-list>
                                        <v-list-item v-for="facture in avis.facture" v-bind:key="facture.id">
                                          <v-list-item-title>{{facture.libelle}}</v-list-item-title>
                                          <v-list-item-action>
                                            <span>{{facture.montantTotal}}</span>
                                          </v-list-item-action>
                                        </v-list-item>
                                      </v-list>
                                    </v-card>
                                  </v-menu>-->
                                  <v-btn color="blue-grey" class="ma-2 white--text elevation-0" v-if="currentDossier.classe === 'Complet' && currentDossier.type === 'Import'" @click="openBad(avis)" small>
                                    <v-icon left>mdi-cash-usd-outline</v-icon> Bon à Délivrer
                                  </v-btn>
                                  <v-btn color="blue-grey" class="ma-2 white--text elevation-0" v-if="currentDossier.classe === 'Complet' && currentDossier.type === 'Import'" @click="openFicheCaisse(avis)" small>
                                    <v-icon left>mdi-cash-usd-outline</v-icon> Fiche de Caisse
                                  </v-btn>
                                  <v-btn :disabled="!permissions.includes('delete_avis')" color="error" class="ma-2 white--text elevation-0" style="float:right;" small @click="deleteAvis(avis)">
                                    <v-icon left>mdi-delete</v-icon> Supprimer
                                  </v-btn>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                        
                      </v-timeline-item>
                    </v-timeline>
                    <v-timeline style="width:98%;" dense v-else>
                      <v-timeline-item left small>
                        <v-alert
                          :value="true"
                          color="primary"
                          icon="mdi-alert-circle-outline"
                          dark
                          class="white--text"
                        >
                          Aucun avis trouvé dans ce dossier.
                        </v-alert>
                      </v-timeline-item>
                    </v-timeline>
                  </v-row>
                  <div v-if="currentDossier.type == 'Import' && currentDossier.classe == 'Complet'">
                  <v-layout class="mt-6">
                     <span class="heading-singleFolder">Proforma</span>
                    <div class="ml-2"><v-btn depressed dense small style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white; border-radius:25px;"  @click="addProforma">Nouveau Proforma</v-btn></div>
                  </v-layout>
                  <v-row>
                    <v-timeline style="width:100%" v-if="currentDa.length > 0" dense>
                      <v-timeline-item
                        v-for="(da, index) in currentDa"
                        :key="da.id"
                        left small
                      >
                        <v-expansion-panels v-model="panel[index]">
                          <v-expansion-panel style="max-width:98%;" @change="changeDaPanel(da.id)">
                            <v-expansion-panel-header>AVIS N°{{da.num_da}}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-card class="elevation-0">
                                <v-card-text class="pt-0 pb-0 pl-0 pr-0">
                                  
                                  <!--
                                  <v-btn color="blue-grey" class="ma-2 white--text elevation-0" v-if="Object.keys(avis.facture).length === 0" @click="openNewFacture(avis.id)" small>
                                    <v-icon left>mdi-cash-usd-outline</v-icon> Facturer
                                  </v-btn>
                                  <v-menu
                                    v-else
                                    open-on-hover
                                    :close-on-content-click="false"
                                    :nudge-width="300"
                                    offset-y
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        color="blue-grey" class="ma-2 white--text elevation-0"
                                        small
                                      >
                                        <v-icon left>mdi-cash-usd-outline</v-icon> Facture(s)
                                      </v-btn>
                                    </template>
                                    <v-card>
                                      <v-list>
                                        <v-list-item v-for="facture in avis.facture" v-bind:key="facture.id">
                                          <v-list-item-title>{{facture.libelle}}</v-list-item-title>
                                          <v-list-item-action>
                                            <span>{{facture.montantTotal}}</span>
                                          </v-list-item-action>
                                        </v-list-item>
                                      </v-list>
                                    </v-card>
                                  </v-menu>-->
                                  <v-btn color="blue-grey" class="ma-2 white--text elevation-0" v-if="currentDossier.classe === 'Complet' && currentDossier.type === 'Import'" @click="openBad(avis)" small>
                                    <v-icon left>mdi-cash-usd-outline</v-icon> Bon à Délivrer
                                  </v-btn>
                                  <v-btn color="blue-grey" class="ma-2 white--text elevation-0" v-if="currentDossier.classe === 'Complet' && currentDossier.type === 'Import'" @click="openFicheCaisse(avis)" small>
                                    <v-icon left>mdi-cash-usd-outline</v-icon> Fiche de Caisse
                                  </v-btn>
                                  <v-btn :disabled="!permissions.includes('delete_avis')" color="error" class="ma-2 white--text elevation-0" style="float:right;" small @click="deleteAvis(avis)">
                                    <v-icon left>mdi-delete</v-icon> Supprimer
                                  </v-btn>
                                </v-card-text>
                              </v-card>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                        
                      </v-timeline-item>
                    </v-timeline>
                    <v-timeline style="width:98%;" dense v-else>
                      <v-timeline-item left small>
                        <v-alert
                          :value="true"
                          color="primary"
                          icon="mdi-alert-circle-outline"
                          dark
                          class="white--text"
                        >
                          Aucun D/A trouvé dans ce dossier.
                        </v-alert>
                      </v-timeline-item>
                    </v-timeline>
                  </v-row>
                  </div>
                  </v-col>
            </v-row>
          </v-card>
          <v-dialog v-model="singleFactureDialog" v-if="singleFactureDialog">
            <single-facture :factureContent="factureContent" v-on:closeSingleFactureDialog="closeSingleFactureDialogMethod" @hide="singleFactureDialog = false"></single-facture>
          </v-dialog>
          <v-dialog v-model="newFactureDialog" v-if="newFactureDialog">
            <new-standard-facture :currentAvis="avisId" :currentDossier="currentDossier" v-on:reloadData="reloadData" :type="`Facture Standard`" @hide="newFactureDialog = false"></new-standard-facture>
          </v-dialog>
          <v-dialog v-model="printDialog" fullscreen v-if="printDialog">
            <print-avis :currentAvis="avisId" v-on:closePrintDialog="closePrintDialogMethod" @hide="printDialog = false"></print-avis>
          </v-dialog>
          <v-dialog v-model="dialog" v-if="dialog">
            <newAvis :currentDossier="currentDossier"  v-on:reloadData="reloadData" @hide="dialog = false"></newAvis>
          </v-dialog>
          <v-dialog v-model="newDaDialog" v-if="newDaDialog" >
            <newDa :currentDossier="currentDossier"  v-on:reloadData="reloadData" @hide="dialog = false"></newDa>
          </v-dialog>
          <v-dialog v-model="editAvisDialog" v-if="editAvisDialog" >
            <edit-avis :currentDossier="currentDossier" :currentAvis="currentAvisToEdit" v-on:reloadData="reloadData" @hide="editAvisDialog = false"></edit-avis>
          </v-dialog>

          <v-dialog v-model="singleFicheCaisse" v-if="singleFicheCaisse" fullscreen>
            <single-fiche-caisse :currentAvis="avisTmp" :currentDossier="currentDossier" v-on:reloadData="reloadData" @hide="singleFicheCaisse = false"></single-fiche-caisse>
          </v-dialog>

          <v-dialog v-model="badDialog" fullscreen v-if="badDialog">
            <print-bad :currentAvis="avisId" @v-on:hide="badDialog = false" @hide="badDialog = false"></print-bad>
          </v-dialog>

        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</v-layout>
</template>

<script>
import headerSidebar from '../commons/header_sidebar.component'
import newAvis from './avis/new.component'
import editAvis from './avis/edit.component'
import printAvis from './avis/print.component'

import newDa from './da/new.component'

import singleFacture from './facture/single.component'
import newFacture from './facture/new.component'
import newStandardFacture from './facture/standard/new.component'
import printBad from './bad/print.component'
import singleFicheCaisse from './fiche_caisse/single.component'

export default {
  name: 'singleFolder',
  props: ['permissions'],
  data: () => ({
    drawer: true,
    business: 5,
    selectedFilter: {},
    mini: false,
    search: '',
    singleFicheCaisse: false,
    navire: null,
    avisTmp: {},
    expanded: [],
    dialog: false,
    badDialog: false,
    printDialog: false,
    singleFactureDialog: false,
    newFactureDialog: false,
    editAvisDialog: false,
    avisId: null,
    factureContent: null,
    newDaDialog: false,
    currentDossier: {},
    currentAvis: [],
    currentDa: [],
    currentAvisToEdit: {},
    headersCargo: [
        { text: 'Rub.', value: 'rub' },
        { text: 'Cont.Numéro', value: 'cont_numero' },
        { text: 'Cont.Type', value: 'cont_type' },
        { text: 'Colis', value: 'colis' },
        { text: 'Description', value: 'description' },
        { text: 'Poids', value: 'poids' }
    ],
    headersCargoGroupage: [
        { text: 'Rub.', value: 'rub' },
        { text: 'Colis', value: 'colis' },
        { text: 'Description', value: 'description' },
        { text: 'Poids', value: 'poids' },
        { text: 'Volume', value: 'volume' }
    ],
    headersCargoAerien: [
        { text: 'Rub.', value: 'rub' },
        { text: 'Colis', value: 'colis' },
        { text: 'Description', value: 'description' },
        { text: 'Poids', value: 'poids' }
    ],
    headersCosts: [
      { text: 'Code', align: 'start', value: 'code_prestation', },
      { text: 'Description des prestations', value: 'description' },
      { text: 'TVA %', value: 'tva' },
      { text: 'Mnt Devise', value: 'montantDevise' },
      { text: 'Devise', value: 'devise' },
      { text: 'Cours', value: 'cour' },
      { text: 'Montant', value: 'montant' },
    ],
    tab: null,
    currentFacture: {},
    items: [
      'GENERAL', 'CARGO', 'COSTS',
    ],
    avisContent: {},
    panel: [],
    cssText: `
      .printing {
        font-family: sans-serif;
        width: 500px;
        border: solid 1px #ccc;
        text-align: center;
        padding: 1em;
        margin: 2em auto;
      }

      button {
        background-color: #f0f0f0;
        border: solid 1px #bbb;
        padding: 10px;
        font-size: 15px;
        border-radius: 5px;
      }

      pre {
        color: #c7254e;
      }
    `,
    loadEdit: false,
    snackbar: false,
    snackbarText: '',
    color: "success",
 
  }),
  components: {
    newDa,
    newAvis,
    editAvis,
    headerSidebar,
    printAvis,
    singleFacture,
    newFacture,
    singleFicheCaisse,
    newStandardFacture,
    printBad
  },
  mounted () {
    this.reloadData()  
  },
  methods: {
      addProforma(){
        this.newDaDialog = true
      },
      reloadData(){
        this.axios
        .get('/dossier/single/'+this.$route.params.id)
        .then(response => {
            this.currentDossier = response.data[0]
          })
        .catch(error => {
          this.$router.push("/dashboard/dossier")
        })
      this.axios
        .get('/dossier/'+this.$route.params.id+'/avis')
        .then(response => {
            var avis = response.data
            avis.forEach((singleAvis, key) => {
              avis[key].totalnt = 0
              avis[key].totalt = 0
              avis[key].totaltva = 0
              avis[key].total = 0
              var prestation = singleAvis.prestations
              prestation.forEach((item , index) => {
                item.cour = Number(item.cour)
                item.montant = Number(item.montant)
                item.montantDevise = Number(item.montantDevise)
                item.tva = Number(item.tva)
                if(item.cour > 0){
                    prestation[index].montant = item.cour * item.montantDevise
                } 
                if(item.tva === 0){
                    avis[key].totalnt= item.montant + avis[key].totalnt
                }else{
                    avis[key].totaltva = item.montant * item.tva / 100  + avis[key].totaltva
                    avis[key].totalt = item.montant + avis[key].totalt
                }
              })
              if(avis[key].facture.length > 0){
               
                avis[key].facture.forEach((item, index) => {
                  var facture_id = item.id
                  var avis_id = item.avis_id
                  avis[key].facture[index].montantTotal = avis[key].timbre
                  avis[key].facture_timbrage = {reglement: []}
                  if(avis_id !== 0){
                    if(item.is_magasinage != 1 && item.is_da != 1 && item.is_surestarie != 1){
                      this.axios.get('/facture/single/'+facture_id)
                      .then(resFact => {
                        avis[key].facture_timbrage = resFact.data
                        /*resFact.data.prestations.forEach((prest,ind) => {
                          avis[key].facture[index].montantTotal = avis[key].facture[index].montantTotal + prest.montant + (prest.montant * prest.tva / 100)
                        })*/
                      })
                    }else{
                      /*this.axios.get('/avis/single/'+avis_id)
                      .then(resAvis => {
                        avis[key].prestations.forEach((prest, ind) => {
                          avis[key].facture[index].montantTotal = avis[key].facture[index].montantTotal + prest.montant + (prest.montant * prest.tva / 100)
                        })
                      })*/
                    }
                  }
                })
              }
              avis[key].total = avis[key].total + avis[key].totalnt + avis[key].totalt + avis[key].totaltva + avis[key].timbre
              this.panel[key] = null
              if(this.$route.query.avisid){
                if(avis[key].id == this.$route.query.avisid){
                  this.panel[key] = 0
                  if(this.$route.query.tab){
                    let tab = this.$route.query.tab
                    if(tab === 'generals'){
                      avis[key].tab = 0
                    }else if(tab === 'cargo'){
                      avis[key].tab = 1
                      console.log('cargo')
                    }else if(tab === 'costs'){
                      avis[key].tab = 2
                    }
                  }
                  
                }
              }
            })
            this.currentAvis = response.data
            console.log(response.data)
          })
      },
      editFolder(id){
        this.$router.push({name: 'updateFolder', params: {id: id}})
      },
      editAvis(id){
        console.log(id)
        this.loadEdit = true
        this.axios.get("/avis/single/"+id)
        .then(response => {
          this.currentAvisToEdit = response.data
        })
        var self = this
        setTimeout(()=>{
          if(self.currentAvisToEdit.id === id){
            self.loadEdit = false
            self.editAvisDialog = true
          }
        },250);
        
      },
      changePanel(id) {
        this.panel.forEach((item, index) => {
          this.panel[index] = null
          this.$router.push({name: 'singleFolder', params: {id: this.currentDossier.id}, query: {avisid: id}}).catch(()=>{})
          
        })
        console.log(this.currentAvis)
      },
      closePrintDialogMethod(){
        this.printDialog = false
      },
      closeNewFactureDialogMethod(){
        this.reloadData()
        this.newFactureDialog = false
      },
      closeSingleFactureDialogMethod(){
        this.singleFactureDialog = false
      },
      addAvis(){
        this.dialog=true;
      },
      printAvis(avisId){
        this.avisId = avisId
        this.printDialog=true 
      },
      openFacture(facture){
        this.factureContent = facture
        this.axios
            .get('/avis/single/'+facture.avis_id)
            .then(response => {
              this.avisContent = response.data
              this.singleFactureDialog=true 
            })
      },
      openBad(avis){
          this.avisId = avis.id
          this.badDialog = true
      },
      openFicheCaisse(avis){
        if(Object.keys(avis.facture).length === 0){
          this.color = "error"
          this.snackbarText = "Impossible de créer une fiche caisse tant que l'avis n'est pas encore facturé et soldé."
          this.snackbar = true
        }else{
          //this.avisTmp = avis
          
          this.axios
              .get('/avis/single/'+avis.id)
              .then(response => {
                var self = this
                var facture = []
                avis.facture.forEach((item, key) =>{
                  let facturetmp = Object.assign({}, item, response.data.facture[key]);
                  facture.push(facturetmp)
                })
                setTimeout(() => {
                  response.data.facture = facture
                  console.log(facture) 
                  self.avisTmp = response.data
                  self.singleFicheCaisse = true
                },0)
                
              })
          
        }
      },
      openNewFacture(id){
        this.avisId = id
        this.newFactureDialog = true
      },
      deleteAvis(avis){
        var index = this.currentAvis.indexOf(avis)
        if(Object.keys(avis.facture).length > 0 || avis.facture.length > 0){
          this.color = "error"
          this.snackbarText = "Impossible de supprimer un avis tant qu'il contient une facture."
          this.snackbar = true
        }else{
          if(confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?')){
              this.axios
                .delete('/avis/delete/'+avis.id)
                .then(response => {
                    this.currentAvis.splice(index, 1)
                    this.color = "success"
                    this.snackbarText = "L'avis a été supprimé avec succès."
                    this.snackbar = true
                })
          }
        }
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.v-expansion-panel {
  box-shadow: 0 11px 25px rgba(0,0,0,0.1);
  border-radius: 25px;
}
.v-expansion-panel:before {
  box-shadow: 0 0 0 transparent;
}

.avis-tab.v-tab{
    background: #ebebeb;
    border-top-right-radius: 50px;
    border-top-left-radius: 15px;
    color: white;
}

.avis-tab.v-tab--active{
    border-top-right-radius: 50px;
    border-top-left-radius: 15px;
    color: white;
    background: linear-gradient(90deg, rgb(13, 74, 186) 0%, rgb(9, 155, 223) 100%);
}

.v-list-item .v-list-item__subtitle, .v-list-item .v-list-item__title {
    text-align: left !important;
}
  .table-content {
    padding: 15px;
  }
  .filter-selectbox{
    margin-left: 16px;
    width: 63%;
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .toggle-second-sidebar {
    float: left;
    width: 48px;
    height: 48px;
    top: 89px;
    transform: translateX(-24px);
    font-size:12px;
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    .toggle-icon {
      margin-left:15px;
    }
  }
  .main-toolbar {
    background: transparent !important;
    .back-dashboard {
      font-size: 12px;
      color: #9ca8b4;
      letter-spacing: 0.02em;
      text-transform: none;
      font-weight: 700;
      .v-icon {
        font-size: 14px;
      }
    }
    .right-btn-group .v-btn {
      margin-left:10px;
      box-shadow: 0px 1px 0px rgba(0,0,0,0.1);
      background: white !important;
      padding: 20px 10px;
      text-transform: none;
      letter-spacing: 0.01em;
      color: #46545c;
      font-size: 12px;
      font-weight: 700;
      &.success {
        background: #70cd0d !important;
        color: white;
      }
      span {
        max-width: 175px;
      }
    }
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .heading-singleFolder {
    font-size: 20px;
    padding-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/dossier/single.vue